<template>
<w-sliding-popup ref="slidingPopup" title="내용 보기" width="600px" @close="onClose">
  <div slot="content">
    <div class="title-h4 title-bar">내용</div>
    <el-input type="textarea" readonly :autosize="{ minRows: 10 }" v-model="contents" placeholder="데이터가 없습니다." />
  </div>
</w-sliding-popup>
</template>

<script>
export default {
  name: 'WCallListDetailPopup',
  data() {
    return {
      contents: null,
    };
  },
  methods: {
    open(contents) {
      this.contents = contents;
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    onClose() {
      this.contents = null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/popup/CallListDetailPopup.vue